export default {
  dark: {
    color: '#ffffff',
    background: '#1f2a30',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#1f2a30',
    hoverBackground: '#ffffff',
  },
  gray: {
    color: '#ffffff',
    background: '#1f1f1f',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#ffffff',
    hoverBackground: '#1f2a30',
  },
  hollow: {
    color: '#000000',
    background: 'transparent',
    border: 'solid 2px #000000',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#ffffff',
    hoverBackground: '#000000',
  },
  light: {
    color: '#000000',
    background: '#ffffff',
    borderRadius: '4px',
    boxShadow: '',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#ffffff',
    hoverBackground: '#000000',
  },
  primary: {
    color: '#ffffff',
    background: '#C10D28',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#ffffff',
    hoverBackground: '#2D8703',
  },
  green: {
    color: '#ffffff',
    background: '#2D8703',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#ffffff',
    hoverBackground: '#2D8703',
  },
  amazon: {
    color: '#333',
    background: '#F2C861',
    borderRadius: '4px',
    // boxShadow: '0 0 8px rgba(0, 0, 0, 0.03), 0 20px 30px rgba(0, 0, 0, 0.1)',
    fontSize: '0.85rem',
    fontWeight: '550',
    letterSpacing: '0.4px',
    lineHeight: '1.2rem',
    padding: '0.5rem 0.5rem',
    textTransform: 'none',
    hoverColor: '#333',
    hoverBackground: '#F4D179',
  },
};
